export enum EventClickAttributes {
  Area = 'data-track-click-area',
  Element = 'data-track-click-element',
  Category = 'data-track-click-category',
  Label = 'data-track-click-label',
  Module = 'data-track-module',
  ModuleType = 'data-track-module-type',
  Position = 'data-track-position',
  Dialog = 'data-track-dialog',
  Delay = 'data-track-delay',
  DyVariationId = 'data-track-dy-variation-id',
  DyDecisionId = 'data-track-dy-decision-id',
  DySlotId = 'data-track-dy-slot-id',
}

export enum EventClickArea {
  Navi = 'navi',
  NaviMain = 'navi-main',
  Breadcrumb = 'breadcrumb',
  Content = 'content',
  Sidebar = 'sidebar',
  Footer = 'footer',
  Dialog = 'layer',
}

export enum EventClickElement {
  Accordion = 'accordion',
  Card = 'card',
  Button = 'button',
  Link = 'link',
  Icon = 'icon',
  Logo = 'logo',
  Image = 'image',
  Video = 'video',
  Custom = 'custom',
}
